module.exports = __webpack_public_path__ + "joy-static/media/Yeti.eb6207fc.png";